import React from 'react';
import Button from '../../../Components/Button/Button';
import { useNavigate } from "react-router-dom";
import "./PricingCard.css";

const PricingItem = ({ plan }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        sessionStorage.setItem("pricing-page-scroll", window.scrollY);

        const container = document.querySelector('.pricingCardGrid');
        if (container) {
            sessionStorage.setItem("pricing-grid-scroll", container.scrollLeft);
        }

        navigate(`/pricing/${plan.id}`);
    };

    return (
        <div className={`pricingCardWrapper pricingCard-${plan.id}`}>
            <div className={`pricingCardTag pricingTag-${plan.id}`}>{plan.tag}</div>

            <div className="pricingPriceInfo">
                <span className={`pricingPriceVal ${plan.id === 'organization' ? 'pricingPriceValOrganization' : ''}`}>
                    {plan.price}
                </span>
                <span className="pricingPriceFreq">{plan.frequency}</span>
            </div>
            
            <h2 className="pricingCardTitle">{plan.title}</h2>
            <p className="pricingCardSub">{plan.subtitle}</p>

            {plan.features?.length > 0 && (
                <ul className="pricingFeatureList">
                    {plan.features.map((feature, index) => (
                        <li key={index} className="pricingFeatureItem">
                            <div className="pricingFeatureIcon">
                                <span className="pricingFeatureTick">✓</span>
                            </div>
                            <span>{feature.text}</span>
                        </li>
                    ))}
                </ul>
            )}

            <Button className='pricingBtn' onClick={handleNavigate}>
                {plan.buttonText}
            </Button>
        </div>
    );
};

export default PricingItem;
